import React from "react";

export function PageHeader({ overline, title, subtitle, action, testid }) {
  return (
    <div className="flex flex-wrap items-end justify-between gap-4 mb-7" data-testid={testid}>
      <div>
        {overline && <div className="overline text-blue-400 mb-1.5">{overline}</div>}
        <h1 className="font-head text-3xl md:text-4xl font-bold tracking-tight text-white">{title}</h1>
        {subtitle && <p className="text-slate-400 mt-2 text-sm max-w-2xl">{subtitle}</p>}
      </div>
      {action}
    </div>
  );
}

const STATUS_STYLE = {
  queued: { c: "#64748b", label: "Queued" },
  running: { c: "#3b82f6", label: "Running" },
  completed: { c: "#22c55e", label: "Completed" },
  failed: { c: "#ef4444", label: "Failed" },
};

export function StatusBadge({ status, testid }) {
  const s = STATUS_STYLE[status] || STATUS_STYLE.queued;
  const pulse = status === "running" || status === "queued";
  return (
    <span
      data-testid={testid}
      className="inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-medium font-mono"
      style={{ color: s.c, borderColor: `${s.c}55`, backgroundColor: `${s.c}15` }}
    >
      <span className={`h-1.5 w-1.5 rounded-full ${pulse ? "animate-pulse" : ""}`} style={{ backgroundColor: s.c }} />
      {s.label}
    </span>
  );
}

const TYPE_STYLE = {
  discovery: "#3b82f6",
  vulnerability: "#eab308",
  exploitation: "#ef4444",
};

export function TypeBadge({ type }) {
  const c = TYPE_STYLE[type] || "#64748b";
  return (
    <span className="inline-flex rounded px-2 py-0.5 text-xs font-medium font-mono capitalize"
      style={{ color: c, backgroundColor: `${c}18`, border: `1px solid ${c}40` }}>
      {type}
    </span>
  );
}

export function EmptyState({ icon: Icon, title, hint }) {
  return (
    <div className="flex flex-col items-center justify-center rounded-lg border border-dashed border-[#1e293b] py-16 text-center">
      {Icon && <Icon size={40} className="text-slate-600 mb-3" weight="duotone" />}
      <div className="text-slate-300 font-medium">{title}</div>
      {hint && <div className="text-slate-500 text-sm mt-1 max-w-sm">{hint}</div>}
    </div>
  );
}

export function fmtDate(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString(undefined, {
      year: "numeric", month: "short", day: "2-digit", hour: "2-digit", minute: "2-digit",
    });
  } catch {
    return iso;
  }
}
